import React from 'react';

class CTABonus2 extends React.Component {
  render() {
    return (
      <div className="container-fluid justify-content-center CTA">
        <h2>SUBSCRIBE TODAY AND RECEIVE EXCLUSIVE BENEFITS</h2>
      </div>
    )
  }
}
export default CTABonus2;
